import { useAuth, useCurrentUser, useTranslation } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { useDeviceInfo } from '@/core/native/device'

import { Action, State } from './template'
import type { PasswordFormValues } from './template/PasswordSettingForm'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { t } = useTranslation('unregisteredPasswordSettings')
  const { user } = useCurrentUser()
  const { deviceInfo } = useDeviceInfo()

  const { updatePassword, linkEmail } = useAuth()

  /**
   * @description
   * メールログインのパスワード登録があるかどうか
   */
  const hasPassword = !!user?.providers.some(
    provider => provider?.providerId === 'password'
  )

  return {
    state: {
      hasPassword,
      forWallet: false,
    },
    actions: {
      onSubmit: async ({
        password,
        newPassword,
      }: Omit<PasswordFormValues, 'confirmNewPassword'>) => {
        return updatePassword(password, newPassword).catch((error: Error) => {
          throw error
        })
      },
      onSubmitUnregisteredPassword: async ({ password }) => {
        if (!user?.email) throw new Error(t('unregisteredEmail'))

        /**
         * @description
         * iOS16ではブラウザでOAuth連携できないため、エラーを表示する
         * https://github.com/firebase/firebase-js-sdk/issues/6716
         */
        if (
          deviceInfo?.operatingSystem === 'ios' &&
          Number(deviceInfo.webViewVersion) >= 16.1
        ) {
          throw new Error(t('iOSOAuthMessage', { ns: 'integrations' }))
        }

        return linkEmail(user.email, password)
      },
      onSubmitWalletPassword: async () => {},
    },
  }
})
